const englishPluralRules = new Intl.PluralRules('en');

export function pluralize(count: number, one: string, other: string): string {
  const word = englishPluralRules.select(count) === 'one' ? one : other;

  return `${count} ${word}`;
}
